const firebaseConfig = {
    apiKey: "AIzaSyB-nAsG4JUf8Y6XTgUSpQ2fGCmjd0C6VXs",
    authDomain: "nidata-99274953-f1a29.firebaseapp.com",
    databaseURL: "https://nidata-99274953-f1a29-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "nidata-99274953-f1a29",
    storageBucket: "nidata-99274953-f1a29.firebasestorage.app",
    messagingSenderId: "296625212118",
    appId: "1:296625212118:web:3619dd3eba368c2f9a9777",
    measurementId: "G-76TRTGSYB4"
};
export default firebaseConfig;
